import { DashboardLayout } from "../components/DashboardLayout";

// Removed OwnerRoute and RequireOrganization to allow both Platform Admins (who might not have org) and Owners to access.
// The page component handles the view switching logic.
export default [DashboardLayout];